import React, { useCallback, useState } from 'react';
import IngredientsModal from './IngredientsModal';
import { showAlertSnackBar } from 'utils/Global';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import useLiquidClassList from './hooks/useLiquidClassList';
import { saveLiquidClass } from 'business/services/IngredientService';
import { ResponseType } from 'business/models/Models';
import { IngredientsModalType } from './IngredientEnums';

const TYPES_COLUMNS = [
  {
    accessor: 'name',
    Header: 'Liquid Class',
    editOptions: { inputType: 'text' },
  },
];

const LiquidClassModal = (props) => {
  const { showLiquidClassModal, setShowLiquidClassModal } = props;
  const [refetchCounter, setRefetchCounter] = useState(0);
  const liquidClassList = useLiquidClassList(showLiquidClassModal, refetchCounter);

  const saveLiquidClassList = useCallback(async (allRows) => {
    const result = await saveLiquidClass(allRows);
    if (result.responseType == ResponseType.Success) {
      showAlertSnackBar(
        EAlertType.SUCCESS,
        ESnackBarPosition.TOP,
        'Liquid Class has been updated successfully!',
      );
      return true;
    } else if (result.responseType == ResponseType.Warning) {
      showAlertSnackBar(EAlertType.WARNING, ESnackBarPosition.TOP, result.message);
      setRefetchCounter(refetchCounter + 1);
      return false;
    }
  }, []);

  return (
    <IngredientsModal
      id='liquidclassmodal-wrapper'
      columns={TYPES_COLUMNS}
      saveModal={saveLiquidClassList}
      rowsData={liquidClassList}
      showModal={showLiquidClassModal}
      setShowModal={setShowLiquidClassModal}
      dialogClassName={'w-96'}
      heading="Liquid Class"
      ingredientsModalType={IngredientsModalType.LiquidClass}
    />
  );
};

export default LiquidClassModal;
